import { getDeviceLocationHeaders } from '../../shared/deviceLocationCache';

/**
 * Kiosk API headers: HttpOnly cookie session + device GPS for server geofence.
 */
export function kioskAuthHeaders(extra = {}) {
  return getDeviceLocationHeaders(extra);
}
